// extracted by mini-css-extract-plugin
module.exports = {"title":"Locations-module--title--32WDu","image":"Locations-module--image--2jJMq","locations":"Locations-module--locations--2bo4k"};